export const PRODUCT_STOCK_OVERLAY = "PRODUCT_STOCK_OVERLAY"
